export class CustomCarousel {
    constructor(carouselElement, hasAutoPlay = false, hasDotNavigation = false) {
        this._activeClass = "active";
        this._rotateSlideClass = "custom-slide-container--rotate";
        this._initialSlideNumber = 1;
        this._touchstartX = 0;
        this._touchendX = 0;
        this.startAutoPlaycustomCarousel = () => {
            if (this._hasAutoPlay) {
                const counterMax = this._slides.length - 1;
                window.playSlider = setInterval(() => {
                    this.nextSlide();
                    //spread out timing of two transitions so they don't happen simultaneously
                    if (this._slideNumber === counterMax) {
                        setTimeout(() => {
                            this.skipCloneSlide();
                        }, 2000);
                    }
                }, 4000);
            }
        };
        this._customCarousel = carouselElement;
        this._hasAutoPlay = hasAutoPlay;
        this._hasDotNavigation = hasDotNavigation;
    }
    /* public methods */
    activateCustomCarousel() {
        this._slideNumber = this._initialSlideNumber;
        this.addcustomCarouselEventListeners();
        this.initializecustomCarousel();
        this.startAutoPlaycustomCarousel();
    }
    deactiveCustomCarousel() {
        if (this._customCarousel) {
            this.stopAutoPlaycustomCarousel();
            this.removeActivecustomCarouselStyling();
            this.removecustomCarouselEventListeners();
            this._customCarousel.classList.remove(this._activeClass);
        }
    }
    /* private methods */
    addcustomCarouselEventListeners() {
        this._prevBtn = this._customCarousel.querySelector(".custom-prev-btn");
        this._nextBtn = this._customCarousel.querySelector(".custom-next-btn");
        this._slideContainer = this._customCarousel.querySelector(".custom-slide-container");
        this._slides = this._slideContainer.querySelectorAll(".custom-slide");
        this._slideContainer.addEventListener("transitionend", () => {
            this.skipCloneSlide();
        });
        this._customCarousel.addEventListener("mouseover", () => {
            this.stopAutoPlaycustomCarousel();
        });
        this._customCarousel.addEventListener("mouseout", () => {
            this.startAutoPlaycustomCarousel();
        });
        const resizeCarousel = new ResizeObserver(() => {
            this._slideWidth = this._slides[0].clientWidth;
            this.nextSlide(false);
        });
        resizeCarousel.observe(this._customCarousel);
        this._nextBtn?.addEventListener("click", () => {
            this.nextSlide();
        });
        this._prevBtn?.addEventListener("click", () => {
            this.prevSlide();
        });
        this._customCarousel.addEventListener("touchstart", (e) => {
            this._touchstartX = e.changedTouches[0].screenX;
        });
        this._customCarousel.addEventListener("touchend", (e) => {
            this._touchendX = e.changedTouches[0].screenX;
            this.swipeSlide();
        });
    }
    swipeSlide() {
        if (this._touchendX < this._touchstartX) {
            this.nextSlide();
        }
        else if (this._touchendX > this._touchstartX) {
            this.prevSlide();
        }
    }
    initializecustomCarousel() {
        this.removeActiveDot();
        this.stopAutoPlaycustomCarousel();
        this._slideNumber = this._initialSlideNumber;
        this._slideWidth = this._slides[0].clientWidth;
        this._countNonCloneSlides =
            this._slides.length === 1 ? 0 : this._slides.length - 2;
        if (this._countNonCloneSlides > 1) {
            this.rotateSlide();
        }
        else {
            this.initializeSingleSlideCarousel();
        }
        this.initializeDots(this._slideNumber);
    }
    initializeSingleSlideCarousel() {
        this._customCarousel.classList.add("single-slide-carousel");
    }
    nextSlide(moveSlide = true) {
        if (this._slideNumber < this._slides.length - 1) {
            this._slideContainer.classList.add(this._rotateSlideClass);
            this._slideNumber = moveSlide ? this._slideNumber + 1 : this._slideNumber;
            const dotNumber = this._slideNumber <= this._countNonCloneSlides ? this._slideNumber : 1;
            this.rotateSlide();
            this.removeActiveDot();
            this.addActiveDot(dotNumber);
        }
    }
    prevSlide() {
        if (this._slideNumber > 0) {
            this._slideContainer.classList.add(this._rotateSlideClass);
            this._slideNumber--;
            const dotNumber = this._slideNumber === 0 ? this._countNonCloneSlides : this._slideNumber;
            this.rotateSlide();
            this.removeActiveDot();
            this.addActiveDot(dotNumber);
        }
    }
    skipCloneSlide() {
        const slideClassName = this._slides[this._slideNumber].className.toLocaleLowerCase();
        if (slideClassName.includes("clone")) {
            this._slideNumber = slideClassName.includes("first")
                ? this._slides.length - this._slideNumber
                : this._countNonCloneSlides;
            this._slideContainer.classList.remove(this._rotateSlideClass);
            this.rotateSlide();
        }
    }
    initializeDots(slideNumber) {
        if (this._hasDotNavigation) {
            const firstDot = this._customCarousel.querySelector(`.custom-dot[data-dot-number="${slideNumber.toString()}"]`);
            firstDot?.classList.add(this._activeClass);
        }
        else {
            const dotNavigationElement = this._customCarousel.querySelector(".custom-dot-container");
            if (dotNavigationElement) {
                dotNavigationElement.classList.add("hide");
            }
        }
    }
    removeActiveDot() {
        if (this._hasDotNavigation) {
            const currentDot = this.getActiveDot();
            if (currentDot) {
                currentDot.classList.remove("active");
            }
        }
    }
    addActiveDot(dotNumber) {
        if (this._hasDotNavigation) {
            const activeDot = this._customCarousel.querySelector(`.custom-dot[data-dot-number="${dotNumber.toString()}"]`);
            activeDot?.classList.add("active");
        }
    }
    getActiveDot() {
        return this._customCarousel.querySelector(".custom-dot.active");
    }
    rotateSlide() {
        this._slideContainer.style.transform =
            "translateX(" + (-this._slideWidth * this._slideNumber - 1) + "px)";
    }
    removeActivecustomCarouselStyling() {
        this._slideContainer.classList.remove(this._rotateSlideClass);
        this._slideContainer.style.transform = "none";
    }
    removecustomCarouselEventListeners() {
        this.removeEventListeners(this._customCarousel);
        this.removeEventListeners(this._slideContainer);
        this.removeEventListeners(this._prevBtn);
        this.removeEventListeners(this._nextBtn);
    }
    stopAutoPlaycustomCarousel() {
        if (window.playSlider) {
            clearInterval(window.playSlider);
        }
    }
    removeEventListeners(element) {
        const oldElement = element;
        const newElement = oldElement?.cloneNode(true);
        oldElement?.parentNode.replaceChild(newElement, oldElement);
    }
}
